"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogsReducer = exports.createCatalogReducer = void 0;
const redux_1 = require("redux");
const products_table_1 = require("./products-table");
const normalized_entity_1 = require("../normalized-entity");
const dashboards_1 = require("./dashboards");
const task_view_1 = require("./task-view");
const constants_1 = require("../shared/selected-l1-categories/constants");
const reducer_1 = require("../shared/selected-l1-categories/reducer");
const store_1 = require("../../strategy-matrix/store");
const selectedL1CategoriesReducer = (0, reducer_1.createSelectedL1CategoriesReducer)(constants_1.SelectedL1CategoriesEntityPrefix.StrategyPreview);
const createCatalogReducer = () => {
    const reducers = (0, redux_1.combineReducers)({
        id: (state = '') => state,
        projectId: (state = '') => state,
        productsTable: products_table_1.productsTableReducer,
        strategyMatrix: store_1.strategyMatrixReducer,
        selectedL1CategoriesAndTerminalNodes: selectedL1CategoriesReducer,
        dashboards: dashboards_1.dashboardsSliceReducer,
        taskView: (0, redux_1.combineReducers)({
            productsTable: task_view_1.taskViewTableReducer,
        }),
    });
    return reducers;
};
exports.createCatalogReducer = createCatalogReducer;
exports.catalogsReducer = (0, normalized_entity_1.normalizedEntityReducer)(normalized_entity_1.NormalizedEntityPrefix.Catalog, (0, exports.createCatalogReducer)());
